import { Injectable } from '@angular/core';
import {
    ApiGatewayService,
    AuthService,
    IFndyObject,
} from '@thinglogix/ngx-foundry-core';
import { from, Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FoundryApiService {
    constructor(
        private apiGatewayService: ApiGatewayService,
        private authService: AuthService
    ) {}

    getObjectsByName(
        searchText: string,
        typeId: string,
        searchField = 'a.name'
    ): Observable<IFndyObject[]> {
        return this.apiGatewayService.getApiClient().pipe(
            switchMap((apiClient) => {
                const query = {
                    account_id: this.authService.user.account_id,
                    groups_only: false,
                    search: searchText,
                    search_field: searchField,
                    type_id: typeId,
                };

                return from(apiClient.Get('/devices/search-service', query));
            }),
            map((result: any) => result.data as IFndyObject[]),
            first()
        );
    }

    getReferencesTo(
        objectId: string,
        withType?: boolean,
        typeId?: string
    ): Observable<any> {
        return this.apiGatewayService.getApiClient().pipe(
            switchMap((apiClient) => {
                const query = {
                    with_types: withType,
                    type_id: typeId,
                };
                return from(
                    apiClient.Get(
                        `/reference/${encodeURIComponent(objectId)}/to`,
                        query
                    )
                );
            }),
            map((result: any) => {
                return result.data;
            }),
            first()
        );
    }

    getObjectsByTypeId(typeId: string): Observable<IFndyObject[]> {
        return this.apiGatewayService.getApiClient().pipe(
            switchMap((apiClient) => {
                const query = {
                    type_id: typeId,
                };

                return from(apiClient.Get('/devices/by-type', query));
            }),
            map((result: any) => result.data as IFndyObject[]),
            first()
        );
    }

    invokeGlobalAction(
        objectId: string,
        actionId: string,
        async = true
    ): Observable<any> {
        return this.apiGatewayService.getApiClient().pipe(
            switchMap((apiClient) => {
                const body = {
                    objectId,
                    actionId,
                    async,
                };
                return from(apiClient.Post('/action', {}, body));
            }),
            map((result: any) => {
                return result.data;
            })
        );
    }
}
